import React from 'react'
import tick from './img/tick.svg'

export const Reasons5 = ({content, lang}) => {

    return (
        <div className='reasons-wrapper'>
            <img src={content.img} className='reasons-img' />
            <div className='reasons-width'>
                <div className={`reasons ${lang}`}>
                    <h2>{content.title}</h2>
                    {
                        content.reasons.map((reason, index) => (
                            <div className='reason' key={index}>
                                <img src={tick} />
                                <div className='reason-text'>
                                    <h3>{reason.reason_title}</h3>
                                    <p>{reason.reason_content}</p>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}